import type { MftpDirectoryService, MftpOhifService, MftpService, MftpStudyService } from '@singular-health/services';
import type { InjectionKey } from 'vue';

export const MFTP_SERVICE_KEY: InjectionKey<MftpService> = Symbol('mftpService');
export const MFTP_DIRECTORY_SERVICE_KEY: InjectionKey<MftpDirectoryService> = Symbol('mftpDirectoryService');
export const MFTP_STUDY_SERVICE_KEY: InjectionKey<MftpStudyService> = Symbol('mftpStudyService');
export const MFTP_OHIF_SERVICE_KEY: InjectionKey<MftpOhifService> = Symbol('mftpOhifService');
